import { StateSchema } from 'app/config/storeConfig/types';
import { Franchise } from 'entities/Franchise';

export const getSelectedFranchise = (state: StateSchema): Nullable<Franchise> => state.createWarehouseModal.selectedFranchise;
